module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-1.081589ca.png";